import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useConvertToPendingPal } from "../../store/useConvertToPendingPal";
import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import CommentInput from "../../../../../resources-vue/vue-custom-elements/CommentInput/CommentInput.vue";

export default defineComponent({
    components: {
        FormSection,
        CommentInput
    },

    computed: {
        ...mapState(useConvertToPendingPal, {
            accountId: "accountId",
            patientId: "patientId",
            patient: "patientDetails",
            application: "application"
        })
    },

    data() {
        return {
            popoverContent:
                "This section can be updated each time the patient identifies a new goal. To save a snapshot of this information, sign the plan of care."
        };
    },

    methods: {
        resultPersonalGoalsAppended(value: string) {
            this.patient.patientGoals.personalGoals += value;
        },
        resultPersonalGoals(value: string) {
            this.patient.patientGoals.personalGoals = value;
        },
        resultCareGoalsAppended(value: string) {
            this.patient.patientGoals.careGoals += value;
        },
        resultCareGoals(value: string) {
            this.patient.patientGoals.careGoals = value;
        },
        resultBarriersGoalsAppended(value: string) {
            this.patient.patientGoals.barriersToPersonalOrCareGoals += value;
        },
        resultBarriersGoals(value: string) {
            this.patient.patientGoals.barriersToPersonalOrCareGoals = value;
        },
        resultCrisisCareAppended(value: string) {
            this.patient.patientGoals.crisisCarePlan += value;
        },
        resultCrisisCare(value: string) {
            this.patient.patientGoals.crisisCarePlan = value;
        }
    }
});
